export default __webpack_public_path__ + "static/media/demiplane_light.883357a5.png";